import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-body-content" }
const _hoisted_2 = { class: "modal-footer-actions" }

import { ref, computed, onMounted } from "vue";
import { Modal, Button, Input, Icon } from "@/components/ui";
import { useEditMeeting } from "@/composables/meetings";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditMeetingTitleModal',
  props: {
    selectedMeeting: {}
  },
  emits: ["closeEditMeetingModal", "refreshMeeting"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const editMeetingMutation = useEditMeeting();

const showModal = ref(true);
const submitError = ref("");

const formData = ref({
  id: null as string | null,
  title: "" as string,
});

const titleTrimmed = computed(() => (formData.value.title ?? "").trim().length > 0);
const isPending = computed(() => editMeetingMutation.isPending.value);

const setValues = () => {
  if (!props.selectedMeeting) return;
  formData.value.id = props.selectedMeeting.id;
  formData.value.title = props.selectedMeeting.title ?? "";
};

const closeModal = () => {
  emit("closeEditMeetingModal");
};

const handleSubmit = async () => {
  const title = (formData.value.title ?? "").trim();
  if (!title) {
    submitError.value = "Title is required";
    return;
  }
  if (!formData.value.id) return;

  submitError.value = "";
  try {
    const result = await editMeetingMutation.mutateAsync({
      id: formData.value.id,
      title,
    } as any);

    emit("refreshMeeting", result ?? { id: formData.value.id, title });
    closeModal();
  } catch (error) {
    console.error("Error updating meeting title:", error);
    submitError.value = "Failed to update title. Please try again.";
  }
};

onMounted(() => {
  setValues();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    show: showModal.value,
    size: "sm",
    "dialog-max-width": "400px",
    "blur-backdrop": false,
    backdropOpacity: 0.5,
    "show-close-button": false,
    onClose: closeModal,
    headerVariant: "blue"
  }, {
    header: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "meeting-header__text" }, [
        _createElementVNode("h2", { class: "meeting-header__title" }, "Edit Meeting Title"),
        _createElementVNode("p", { class: "meeting-header__subtitle" }, "Update the meeting title")
      ], -1)),
      _createElementVNode("button", {
        type: "button",
        class: "meeting-header__close",
        onClick: closeModal,
        "aria-label": "Close"
      }, [
        _createVNode(_unref(Icon), {
          icon: "mdi:close",
          width: "18",
          height: "18"
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Input), {
          modelValue: formData.value.title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.title) = $event)),
          label: "Title",
          type: "text",
          placeholder: "Enter meeting name",
          error: submitError.value,
          "leading-icon": "mdi:format-title",
          required: ""
        }, null, 8, ["modelValue", "error"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Button), {
          variant: "secondary",
          onClick: closeModal
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" Cancel ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(Button), {
          variant: "primary",
          loading: isPending.value,
          disabled: !titleTrimmed.value,
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" Save ", -1)
          ]))]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})